<template>
    <div>
<!--        <strong>{{ $_.get(activity, "payload.name") }} </strong>-->
<!--        changed status from-->
<!--        <strong>{{ $_.get(activity, "payload.oldStatus") }}</strong>-->
<!--        to-->
<!--        <strong>{{ $_.get(activity, "payload.newStatus") }}</strong>-->
        <span v-html="$t('notification.userStatusChanged', { name: $_.get(activity, 'payload.name'), oldStatus:$_.get(activity, 'payload.oldStatus'),newStatus:$_.get(activity, 'payload.newStatus') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserStatusChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
